// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"367fc607","160":"28f8f5aa","386":"6bc75d35","475":"56b3dea8","867":"22914931","879":"6b97990f","921":"33434d1e","933":"0d4be624"}[chunkId] + ".chunk.js";
};